import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

export const blockSwaggerInProductionGuard: CanActivateFn = () => {
  if (environment.environment !== 'Prod') {
    return true;
  }
  const router = inject(Router);
  return router.createUrlTree(['', 'home']);
};
